module.exports = __webpack_public_path__ + "media/images/countryrect/cc-cb005a47c38ed9cf07eaffdbfdbe216c.svg";